import React from 'react'
import { Box, Typography, Avatar, List, ListItem, ListItemAvatar, ListItemText, Divider } from '@mui/material'
import { Person, DoneAll } from '@mui/icons-material'
import { useUsersContext } from '../../context/Users.context'

const NewsReadersList = ({ readBy = [] }) => {
    const { usersMap } = useUsersContext()

    const uniqueIds = Array.from(new Set((readBy || []).map(userId =>
        typeof userId === 'string' ? userId : userId?.$oid || userId?._id
    )))

    const readers = uniqueIds.map(id => usersMap[id]).filter(user => !!user)

    return (
        <Box sx={{ width: 280, borderLeft: '1px solid #eee', bgcolor: '#fff', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ p: 2, bgcolor: '#fcfcfc', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', gap: 1 }}>
                <DoneAll sx={{ color: 'green', fontSize: 20 }} />
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Visto por ({readers.length})</Typography>
            </Box>
            <List sx={{ flexGrow: 1, overflowY: 'auto', p: 0 }}>
                {readers.length > 0 ? (
                    readers.map((user, i) => (
                        <React.Fragment key={user._id}>
                            <ListItem alignItems="flex-start" sx={{ px: 2, py: 1.5 }}>
                                <ListItemAvatar sx={{ minWidth: 40 }}>
                                    <Avatar sx={{ width: 32, height: 32, bgcolor: 'brown', fontSize: 14 }}>
                                        {user.name?.charAt(0)}{user.lastName?.charAt(0)}
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={<Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.8rem' }}>{user.name} {user.lastName}</Typography>}
                                    secondary={
                                        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', fontSize: '0.7rem' }}>
                                            {user.role?.name || 'Usuario'}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                            {i < readers.length - 1 && <Divider variant="inset" component="li" sx={{ ml: 7, mr: 2, opacity: 0.5 }} />}
                        </React.Fragment>
                    ))
                ) : (
                    <Box sx={{ p: 4, textAlign: 'center', opacity: 0.5 }}>
                        <Typography variant="caption">Nadie ha leído esta noticia aún.</Typography>
                    </Box>
                )}
            </List>
        </Box>
    )
}

export default NewsReadersList
